// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"b3de88eb","247":"1c8bb471","627":"8b4d2177","834":"e7cbad4d","867":"024020e3","923":"6d61c773","938":"58da2f92"}[chunkId] + ".chunk.js";
};